import { Component, OnInit, inject } from '@angular/core';
import { HlmDropdownMenuImports } from '../../../../ui/dropdown-menu/src';
import { HlmButton } from '../../../../ui/button/src';
import { UsersService } from '@core/services/users.service';
import { injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { User } from 'src/app/core/models/users';

export interface EditUserDetailsDialogContext {
  user: User;
  close: (result?: { action: string; payload?: any } | null) => void;
}

@Component({
  selector: 'app-edit-user-details-dialog',
  styles: [':host { display: block; max-width: 600px }'],
  template: `
    <div class="p-6">
      <h2 class="text-center text-xl font-semibold mb-4">Edit user</h2>

      <div class="flex flex-col items-center">
        <div class="my-3 space-x-2">
          <button (click)="onCancel()" hlmBtn variant="outline">Cancel</button>
          <button
            (click)="onSave()"
            [disabled]="!userFormState"
            hlmBtn
            variant="outline">
            Save
          </button>
        </div>
        <div class="pb-1">
          <button hlmBtn variant="outline" [hlmDropdownMenuTrigger]="menu">Delete permanently</button>
          <ng-template #menu>
            <hlm-dropdown-menu>
              <button hlmDropdownMenuItem (click)="deleteUser()">Yes</button>
              <button hlmDropdownMenuItem>Cancel</button>
            </hlm-dropdown-menu>
          </ng-template>
        </div>
      </div>
    </div>
  `,
  imports: [HlmButton, ...HlmDropdownMenuImports],
})
export class EditUserDetailsDialogComponent implements OnInit {
  private context = injectBrnDialogContext<EditUserDetailsDialogContext>();
  private userSvc = inject(UsersService);

  data = { user: this.context.user };

  userFormValue: any;

  userFormState!: boolean;

  ngOnInit(): void {}

  onFormValueChange(value: any) {
    this.userFormValue = value;
  }

  onFormStateChange(value: boolean) {
    this.userFormState = value;
  }

  onCancel(): void {
    this.context.close(null);
  }

  onSave(): void {
    this.context.close({ action: 'update', payload: this.userFormValue });
  }

  deleteUser() {
    this.userSvc.destroy(this.data.user._id).subscribe(() => this.context.close({ action: 'delete' }));
  }
}
